// test1806
(1806 && 0);
